import CATEGORIES from '#app/data/competency-categories.json'
import ABILITIES from '#app/data/persona-competencies.json'

export const CategoryKey = {
	ProblemSolving: 'ProblemSolving',
	KnowledgeAndSkills: 'KnowledgeAndSkills',
	Communication: 'Communication',
	TeamWork: 'TeamWork',
	AdaptabilityToChange: 'AdaptabilityToChange',
	Leadership: 'Leadership',
	HumanResourceDevelopment: 'HumanResourceDevelopment',
}

export const getAbility = (key: string) => {
	const found = ABILITIES.find(element => element.key === key)
	if (!found) {
		throw new Error(`not found ability by key: ${key}`)
	}
	return found
}
export const getAbilityName = (key: string) => {
	return getAbility(key).name
}
export const getAbilityDescription = (key: string) => {
	return getAbility(key).description
}
export const getAbilityCategory = (key: string) => {
	return getAbility(key).category
}
export const getAbilityCategoryOrder = (key: string) => {
	return getCategory(getAbilityCategory(key)).order
}
export const getAbilitiesByCategory = (category: string) => {
	const found = ABILITIES.filter(element => element.category === category)
	if (!found) {
		throw new Error(`not found ability by category: ${category}`)
	}
	return found
}
export const getCategory = (category: string) => {
	const found = CATEGORIES.find(element => element.category === category)
	if (!found) {
		throw new Error(`not found ability by category: ${category}`)
	}
	return found
}
export const getCategoryByLabel = (label: string) => {
	const found = CATEGORIES.find(element => element.label === label)
	if (!found) {
		throw new Error(`not found category by label : ${label}`)
	}
	return found
}
export const getCategoryLabel = (category: string) => {
	return getCategory(category).label
}
export const getCategoryOrderByLabel = (label: string) => {
	const found = getCategoryByLabel(label)
	const order = found.order
	if (!order) {
		throw new Error('not found order')
	}
	return order
}
export const getCategoryLabelByAbilityKey = (key: string) => {
	return getCategoryLabel(getAbilityCategory(key))
}
export const isMemberAbility = (key: string) => {
	const category = getAbilityCategory(key)
	return (
		CATEGORIES.find(element => element.category === category)?.group ===
		'Member'
	)
}
export const isManagerOrSpecialistAbility = (key: string) => {
	const category = getAbilityCategory(key)
	return (
		CATEGORIES.find(element => element.category === category)?.group ===
		'ManagerOrSpecialist'
	)
}
